function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#EB5757"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4141 19.9998L27.7071 13.7068C28.0981 13.3158 28.0981 12.6838 27.7071 12.2928C27.3161 11.9018 26.6841 11.9018 26.2931 12.2928L20.0001 18.5858L13.7071 12.2928C13.3161 11.9018 12.6841 11.9018 12.2931 12.2928C11.9021 12.6838 11.9021 13.3158 12.2931 13.7068L18.5861 19.9998L12.2931 26.2928C11.9021 26.6838 11.9021 27.3158 12.2931 27.7068C12.4881 27.9018 12.7441 27.9998 13.0001 27.9998C13.2561 27.9998 13.5121 27.9018 13.7071 27.7068L20.0001 21.4138L26.2931 27.7068C26.4881 27.9018 26.7441 27.9998 27.0001 27.9998C27.2561 27.9998 27.5121 27.9018 27.7071 27.7068C28.0981 27.3158 28.0981 26.6838 27.7071 26.2928L21.4141 19.9998Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 11,
  width: 18,
  height: 17
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4141 19.9998L27.7071 13.7068C28.0981 13.3158 28.0981 12.6838 27.7071 12.2928C27.3161 11.9018 26.6841 11.9018 26.2931 12.2928L20.0001 18.5858L13.7071 12.2928C13.3161 11.9018 12.6841 11.9018 12.2931 12.2928C11.9021 12.6838 11.9021 13.3158 12.2931 13.7068L18.5861 19.9998L12.2931 26.2928C11.9021 26.6838 11.9021 27.3158 12.2931 27.7068C12.4881 27.9018 12.7441 27.9998 13.0001 27.9998C13.2561 27.9998 13.5121 27.9018 13.7071 27.7068L20.0001 21.4138L26.2931 27.7068C26.4881 27.9018 26.7441 27.9998 27.0001 27.9998C27.2561 27.9998 27.5121 27.9018 27.7071 27.7068C28.0981 27.3158 28.0981 26.6838 27.7071 26.2928L21.4141 19.9998Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgRedCheck = function SvgRedCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red-check.d96405ae.svg";
export { ForwardRef as ReactComponent };